import { useState, FC } from 'react'
import DateEntry, { DateEntryValue } from '@components/forms/DateEntry'
import { EditableDate } from '@app-types/entity_types'

type DateSelectorProps = {
  value: EditableDate | null
  name: 's' | 'e'
  label?: string
  onChange?: (data: { name: 's' | 'e'; value: EditableDate | null }) => void
  className?: string
}

const DateSelector: FC<DateSelectorProps> = ({ value, name, label, onChange, className = 'date-selector' }) => {
  if (value === null) {
    value = {
      day: '',
      month: '',
      year: '',
      isBCE: false,
    }
  }

  const [editableDate, setEditableDate] = useState(value)

  const handleChange = (event: { value: EditableDate }) => {
    const nextEditableDate = event.value
    setEditableDate(nextEditableDate)

    if (onChange) {
      onChange({
        name,
        value: nextEditableDate,
      })
    }
  }

  const legend = label || name
  const dateEntryValue = editableDate as DateEntryValue
  return (
    <div className={className}>
      <DateEntry legend={legend} key="picker" name={name} value={dateEntryValue} onChange={handleChange} />
    </div>
  )
}

export default DateSelector
